import axios from "axios";
import { resolveApiBaseUrl } from "@/config/apiBaseUrl";

const axiosInstance = axios.create({
  baseURL: resolveApiBaseUrl(),
});

// Request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
      // Get the token, username, userRole from localStorage
      const token = localStorage.getItem('token');
      const username = localStorage.getItem('username');
      const userrole = localStorage.getItem('userrole');

      // If username or userRole or username not exist redirect to /singin
      if (!username || !userrole) {
          console.error('Unauthorized! Redirecting to login...');
          localStorage.clear()
          window.location.href = '/#/auth/signin';}

      // If the token exists, add it to the headers of the request
      if (token) {
          config.headers['Authorization'] = `Bearer ${token}`;
      }
      return config;
  },
  (error) => {
    // Handle request errors here
    return Promise.reject(error);
  }
);

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    // You can handle the response here if needed
    return response;
  },
  (error) => {
    // Handle errors globally, like token expiration
    if (error.response && error.response.status === 401) {
      // Handle 401 Unauthorized errors (e.g., redirect to login)
      console.error('Unauthorized! Redirecting to login...');
      localStorage.clear()
      window.location.href = '/#/auth/signin';
      // You can add logic to redirect to login page or handle token refresh here
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
